import { useState } from "react";
import { Check, Copy } from "lucide-react";

interface Props {
  rawKey: string;
  onDismiss: () => void;
}

export default function NewKeyBanner({ rawKey, onDismiss }: Props) {
  const [copied, setCopied] = useState(false);

  function copy() {
    navigator.clipboard.writeText(rawKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div className="rounded-xl border border-amber-400/40 bg-amber-50 dark:bg-amber-950/30 p-4 mb-6">
      <p className="text-sm font-semibold text-amber-700 dark:text-amber-400 mb-1">
        New API key — copy now, it won't be shown again
      </p>
      <div className="flex items-center gap-2 mt-2">
        <code className="flex-1 rounded-lg bg-white dark:bg-black/30 border border-border px-3 py-2 text-xs font-mono text-foreground break-all select-all">
          {rawKey}
        </code>
        <button
          onClick={copy}
          className="flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center border border-border bg-white dark:bg-black/30 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Copy API key"
        >
          {copied ? (
            <Check className="w-4 h-4 text-green-500" />
          ) : (
            <Copy className="w-4 h-4" />
          )}
        </button>
      </div>
      <button
        onClick={onDismiss}
        className="mt-3 text-xs text-amber-600 dark:text-amber-400 hover:underline"
      >
        I've saved it, dismiss
      </button>
    </div>
  );
}
